import styled from 'styled-components'
import { TwoColumnFeatureGridWithListBlockRecord } from 'types'

import { Container } from '@/components/shared/Container'

import { TwoColumnFeatureCardWithList } from './TwoColumnFeatureCardWithList'

const StyledMainContainer = styled.section`
  padding: 96px 0 64px 0;
  text-align: center;
  background-color: ${(p) => p.theme.v2.surface.cream500};

  @media screen and (max-width: ${(p) => p.theme.breakpoints.tablet}) {
    max-width: 75%vw;
    padding: 80px 100px 64px 100px;
  }
  @media screen and (max-width: ${(p) => p.theme.breakpoints.mobile}) {
    padding: 80px 0px 40px 0px;
  }
`

const StyledHeading = styled.div`
  margin-bottom: 60px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .pre-title {
    font-size: ${(p) => p.theme.v2.typography.body.m.fontSize};
    line-height: ${(p) => p.theme.v2.typography.body.m.lineHeight};
    margin-bottom: 8px;
  }

  h2 {
    font-size: ${(p) => p.theme.v2.typography.display.xxs.fontSize};
    line-height: ${(p) => p.theme.v2.typography.display.xxs.lineHeight};
    font-family: ${(p) => p.theme.v2.font.nantes};
    color: ${(props) => props.theme.v2.onSurface.text};
    margin: 8px 0 0;
    @media screen and (max-width: ${(p) => p.theme.breakpoints.tablet}) {
      font-size: ${(p) => p.theme.v2.typography.body.xl.fontSize};
      line-height: ${(p) => p.theme.v2.typography.body.xl.lineHeight};
    }
    @media screen and (max-width: ${(p) => p.theme.breakpoints.mobile}) {
      margin: 0 24px;
    }

    i {
      font-family: ${(p) => p.theme.v2.font.nantesItalic};
    }
  }

  p {
    font-family: ${(p) => p.theme.v2.font.lotaGrotesqueLight};
    color: ${(props) => props.theme.v2.onSurface.subduedText};
    font-size: ${(p) => p.theme.v2.typography.body.s.fontSize};
    line-height: ${(p) => p.theme.v2.typography.body.s.lineHeight};
    width: 40vw;
    margin-top: 16px;
  }

  @media screen and (max-width: ${(p) => p.theme.breakpoints.tablet}) {
    margin-bottom: 55px;
    p {
      width: 50vw;
      font-size: ${(p) => p.theme.v2.typography.body.xs.fontSize};
      line-height: ${(p) => p.theme.v2.typography.body.xs.lineHeight};
    }
  }
  @media screen and (max-width: ${(p) => p.theme.breakpoints.mobile}) {
    p {
      width: 70vw;
    }
  }
`

const StyledGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr;
  gap: 40px;

  @media screen and (max-width: ${(p) => p.theme.breakpoints.tablet}) {
    grid-template-columns: 1fr;
    grid-template-rows: 1fr 1fr;
    gap: 24px;
  }
`
type TwoColumnFeatureGridWithListProps = {
  content: TwoColumnFeatureGridWithListBlockRecord
}

const HOW_IT_WORKS_TWO_COLUMN_TITLE = 'ZOE comes in two parts: the test kit and the membership'
const renderedHowItWorksTwoColumnTitle = () => (
  <h2>
    ZOE comes in two parts: the <i>test kit</i> and the <i>membership</i>
  </h2>
)
export const TwoColumnFeatureGridWithList = ({ content }: TwoColumnFeatureGridWithListProps) => {
  const { preTitle, title, description, cards } = content
  return (
    <StyledMainContainer>
      <Container>
        <StyledHeading>
          {preTitle && <p className="pre-title">{preTitle}</p>}
          {title && title === HOW_IT_WORKS_TWO_COLUMN_TITLE ? renderedHowItWorksTwoColumnTitle() : <h2>{title}</h2>}
          {description && <p>{description}</p>}
        </StyledHeading>

        <StyledGrid>
          {cards.map((card) => {
            const { id, title, listContent, description, textBlock, image } = card
            return (
              <TwoColumnFeatureCardWithList
                key={id}
                image={image?.responsiveImage}
                title={title}
                listContent={listContent}
                description={description}
                textBlock={textBlock}
              />
            )
          })}
        </StyledGrid>
      </Container>
    </StyledMainContainer>
  )
}
